/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonEventPartySeating
 */
export interface JsonEventPartySeating {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof JsonEventPartySeating
     */
    tables?: { [key: string]: string; };
}

export function JsonEventPartySeatingFromJSON(json: any): JsonEventPartySeating {
    return JsonEventPartySeatingFromJSONTyped(json, false);
}

export function JsonEventPartySeatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonEventPartySeating {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tables': !exists(json, 'tables') ? undefined : json['tables'],
    };
}

export function JsonEventPartySeatingToJSON(value?: JsonEventPartySeating | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tables': value.tables,
    };
}

